import { EditGroupComponent } from './edit-group/edit-group.component';
import { AddGroupComponent } from './add-group/add-group.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ListGroupsComponent } from './list-groups/list-groups.component';

export const routesGroup: Routes = [
    { path: 'page-cfg-group', component: ListGroupsComponent },
    { path: 'page-cfg-group/add', component: AddGroupComponent },
    { path: 'page-cfg-group/:id/edit', component: EditGroupComponent },
];

export const GroupRoutes: ModuleWithProviders = RouterModule.forChild(routesGroup);
